// src/services/notificacionesNativas.js
import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { supabase } from '../lib/supabaseClient';
import { PushNotifications } from '@capacitor/push-notifications';

let canal = null;

export async function iniciarNotificacionesNativas(userId, navigate) {
  if (!Capacitor.isNativePlatform() || !userId) return;

  const perm = await LocalNotifications.requestPermissions();
  if (perm.display !== 'granted') return;

  await LocalNotifications.createChannel({
    id: 'calypso-general',
    name: 'Notificaciones de Calypso',
    importance: 4,
    vibration: true,
  });

  await LocalNotifications.removeAllListeners();
  LocalNotifications.addListener('localNotificationActionPerformed', () => {
    navigate('/home');
  });

  if (canal) supabase.removeChannel(canal);
  canal = supabase
    .channel('notif-nativas-' + userId)
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'notifications',
        filter: `user_id=eq.${userId}`,
      },
      (payload) => {
        const n = payload.new;
        LocalNotifications.schedule({
          notifications: [{
            id: Math.floor(Math.random() * 2147483647),
            title: n.title || 'Calypso',
            body: n.message || '',
            channelId: 'calypso-general',
            extra: { type: n.type, metadata: n.metadata },
          }],
        });
      }
    )
    .subscribe();
}

export function detenerNotificacionesNativas() {
  if (canal) { supabase.removeChannel(canal); canal = null; }
}
export async function registrarPush(userId, navigate) {
  if (!Capacitor.isNativePlatform() || !userId) return;

  const perm = await PushNotifications.requestPermissions();
  if (perm.receive !== 'granted') return;

  await PushNotifications.removeAllListeners();

  PushNotifications.addListener('registration', async ({ value }) => {
    const { error } = await supabase.from('device_tokens').upsert(
      { user_id: userId, token: value, platform: Capacitor.getPlatform(), updated_at: new Date().toISOString() },
      { onConflict: 'token' }
    );
    if (error) console.error('Error guardando token', error);
  });

  PushNotifications.addListener('registrationError', (e) =>
    console.error('Error registrando FCM', e)
  );

  PushNotifications.addListener('pushNotificationActionPerformed', () => {
    navigate('/home');
  });

  await PushNotifications.register();
}